import { LIST_TABS, SESSION_STATUS_LABEL, formatWaitSeconds, sessionTitle } from '../csConstants';

function formatEndedAt(item) {
  const raw = item?.endedAt || item?.abandonedAt;
  if (!raw) return '—';
  try {
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return String(raw);
    return d.toLocaleString();
  } catch {
    return String(raw);
  }
}

export default function SessionListPanel({
  tab,
  onTabChange,
  queueItems,
  mySessions,
  endedSessions,
  selectedSessionId,
  onSelect,
  onClaim,
  loading,
  error,
  claimingId,
}) {
  return (
    <div className="cs-panel">
      <div className="cs-tabs">
        <button
          type="button"
          className={tab === LIST_TABS.QUEUE ? 'is-active' : ''}
          onClick={() => onTabChange(LIST_TABS.QUEUE)}
        >
          等待佇列
        </button>
        <button
          type="button"
          className={tab === LIST_TABS.MINE ? 'is-active' : ''}
          onClick={() => onTabChange(LIST_TABS.MINE)}
        >
          我的進行中
        </button>
        <button
          type="button"
          className={tab === LIST_TABS.ENDED ? 'is-active' : ''}
          onClick={() => onTabChange(LIST_TABS.ENDED)}
        >
          已結束
        </button>
      </div>
      {error ? <div className="cs-error">{error}</div> : null}
      {loading ? <div className="cs-hint">載入中…</div> : null}
      <div className="cs-list">
        {tab === LIST_TABS.QUEUE && (queueItems || []).map((item) => (
          <div
            key={item.sessionId}
            className={`cs-list-item ${selectedSessionId === item.sessionId ? 'is-selected' : ''}`}
            role="button"
            tabIndex={0}
            onClick={() => onSelect(item)}
            onKeyDown={(e) => e.key === 'Enter' && onSelect(item)}
          >
            <div className="cs-list-item__title">{sessionTitle(item)}</div>
            <div className="cs-list-item__meta">
              {item.category || '—'} · {item.language || '—'} · 等待 {formatWaitSeconds(item.waitingDurationSeconds)}
            </div>
            {item.preview ? <div className="cs-list-item__preview">{item.preview}</div> : null}
            <div className="cs-list-item__actions">
              <button
                type="button"
                className="btn btn-primary btn-sm"
                disabled={claimingId === item.sessionId || item.canClaim === false}
                title={
                  item.canClaim === false
                    ? (item.eligibilityReasonCodes || []).join(', ') || '目前不可接手'
                    : '接手此案件'
                }
                onClick={(e) => {
                  e.stopPropagation();
                  onClaim(item);
                }}
              >
                {claimingId === item.sessionId ? '接手中…' : '接手'}
              </button>
            </div>
          </div>
        ))}
        {tab === LIST_TABS.MINE && (mySessions || []).map((item) => (
          <div
            key={item.sessionId}
            className={`cs-list-item ${selectedSessionId === item.sessionId ? 'is-selected' : ''}`}
            role="button"
            tabIndex={0}
            onClick={() => onSelect(item)}
            onKeyDown={(e) => e.key === 'Enter' && onSelect(item)}
          >
            <div className="cs-list-item__title">{sessionTitle(item)}</div>
            <div className="cs-list-item__meta">
              {SESSION_STATUS_LABEL[item.status] || item.status || '—'}
              {item.category ? ` · ${item.category}` : ''}
            </div>
          </div>
        ))}
        {tab === LIST_TABS.ENDED && (endedSessions || []).map((item) => (
          <div
            key={item.sessionId}
            className={`cs-list-item ${selectedSessionId === item.sessionId ? 'is-selected' : ''}`}
            role="button"
            tabIndex={0}
            onClick={() => onSelect(item)}
            onKeyDown={(e) => e.key === 'Enter' && onSelect(item)}
          >
            <div className="cs-list-item__title">{sessionTitle(item)}</div>
            <div className="cs-list-item__meta">
              {SESSION_STATUS_LABEL[item.status] || item.status || '—'}
              {item.endReason ? ` · ${item.endReason}` : ''}
            </div>
            <div className="cs-list-item__preview">{formatEndedAt(item)}</div>
          </div>
        ))}
        {!loading && tab === LIST_TABS.QUEUE && !(queueItems || []).length ? (
          <div className="cs-empty">目前沒有等待中的案件</div>
        ) : null}
        {!loading && tab === LIST_TABS.MINE && !(mySessions || []).length ? (
          <div className="cs-empty">尚無進行中的 Session</div>
        ) : null}
        {!loading && tab === LIST_TABS.ENDED && !(endedSessions || []).length ? (
          <div className="cs-empty">尚無已結束的 Session</div>
        ) : null}
      </div>
    </div>
  );
}
